<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5 py-2" cols="12" md="9">
      <v-col cols="12">
        <v-btn icon title="Número de radicación" aria-label="Número de radicación">
          <v-icon size="60">fas fa-list-ol</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
        >Número de Radicación</span>
        <br />
        <!-- <span :class="$vuetify.breakpoint.xs ? 'font-weight-regular body-1' : 'font-weight-regular title'">Aqui encontrará la manera más fácil de consultar su proceso</span> -->

        <!-- <v-row>
        </v-row>-->
      </v-col>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center" justify="center">
          <v-col cols="10" md="7">
            <v-card elevation="10" class="px-5 py-1 processFilterBox">
              <v-radio-group v-model="soloActivos" mandatory>
                <v-radio
                  color="primary"
                  :value="true"
                  label="Procesos con Actuaciones Recientes (últimos 30 días)"
                />
                <v-radio
                  color="primary"
                  :value="false"
                  label="Todos los Procesos (consulta completa, menos rápida)"
                />
              </v-radio-group>
            </v-card>
          </v-col>

          <v-col cols="10" md="8" class="mt-4">
            <v-text-field
              outlined
              counter
              maxlength="23"
              v-model="idRadicacion"
              @keypress.prevent.enter="find"
              placeholder="Ingrese los 23 dígitos del número de Radicación"
              oninput="this.value=this.value.replace(/[^0-9]/g,'');"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="mt-n2">
          <v-btn
            :loading="getStatus.loading"
            color="success"
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            aria-label="Consultar Número de radicación"
            @click="
              consultar
            "
          >Consultar</v-btn>
          <v-btn
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            dark
            color="grey"
            @click="reset"
            aria-label="Nueva Consulta Número de radicación"
          >Nueva Consulta</v-btn>
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
// // // import axios from "../../config/axios";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    soloActivos: true,
    valid: true,
    show: false,
    loading: false,
    consulted: false,
    inicio: false,
    duplicated: 0,
    dup: [],
    nameRules: [
      (v) => !!v || "Número de Radicación requerido",
      (v) =>
        (v && v.length == 23) ||
        "El número de Radicación ha de ser de 23 dígitos",
    ],
    idRadicacion: "",
    status: {
      loading: false,
      error: false,
      message: "",
    },
    message: "",
    alertType: "info",
  }),
  computed: {
    ...mapGetters("process", [
      "getProcesos",
      "getSearch",
      "getDetails",
      "getStatus",
      "getDuplicated",
      "getPaginaActualProcesos",
    ]),
  },
  watch: {
    getPaginaActualProcesos(pagina) {
      if (this.getProcesos.length) {
        this.find();
      }
    },
  },
  // // // created() {
  // // //   this.idRadicacion = ""; ////this.getSearch;
  // // //   this.soloActivos = this.getSoloActivos;
  // // // },
  mounted() {
    if (this.radicacionModal) {
      this.show = this.radicacionModal.show;
      this.consulted = this.radicacionModal.consulted;
      this.message = this.radicacionModal.message;
    }
  },
  methods: {
    consultar() {
      if (this.$refs.form.validate()) {
        this.$emit("clear-process-id");
        this.$store.dispatch("process/setProcesos", []);
        this.$store.dispatch("process/setPaginaProcesos", 1);
        this.$store.commit("process/setPaginacion", {
          name: "paginacionProcesos",
          value: {
            ...this.getPaginacionProcesos,
            pagina: 1,
          },
        });
        this.find();
      }
    },
    async find() {
      if (this.$refs.form.validate()) {
        let payload = {
          id: this.idRadicacion,
          soloActivos: this.soloActivos,
        };

        await this.$store.dispatch("process/numRadicacion", payload);
        this.$emit("goToList");

        if (!this.getProcesos.length) {
          this.consulted = true;

          if (!this.getStatus.error) {
            this.$store.dispatch(
              "process/mostrarNotificacionRespuestaVacia",
              this.soloActivos
            );
          } else {
            this.$store.dispatch("process/mostrarNotificacionError");
          }
        } else {
          if (this.getProcesos.length > 1) {
            this.consulted = true;
            this.$store.dispatch("process/mostraNotificacionVariosRegistros");
          }

          this.$emit("go-to-list");
        }
        this.duplicated = 0;
      }
    },
    reset() {
      this.show = false;
      this.idRadicacion = "";
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$store.dispatch("process/clearProcesos");
      // // this.$router.push("/Procesos/NumeroRadicacion");
      //this.$router.go(0);

      ///this.idRadicacion = "";
      
      // // if (this.$router.currentRoute.path != "/Procesos/NumeroRadicacion") {
      // //   this.$router.push("/Procesos/NumeroRadicacion");
      // // }
      // // if (this.$route.meta.active) {
      // //   this.$router.push("/Procesos/NumeroRadicacion");
      // // }

      this.duplicated = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.processFilterBox {
  border: 0.1rem solid rgba(0, 0, 0, 0.8);
  border-radius: 1rem !important;
}
</style>
